// Service di comunicazione con i backend (CEO/CBB)

import Axios from "axios";
import { FORMAT, ERROR } from "../utils/Constants.js";

//var JSONbig = require("json-bigint")({ storeAsString: true });
// serve a gestire il diverso formato dei long tra java e javascript (64 vs 52 bit)

const CEOURL = process.env.https://uvote2-webcounting.prod.cineca.it/;
const apiPrefix = process.env.VUE_APP_apiPrefix;

class CeoCbbService {
  ceourl;
  //cbbUrl;
  token;
  headersJson;
  keycloak;

  constructor(keycloak) {
    this.ceourl = CEOURL;
    // this.cbbUrl = CBBURL;
    this.token = keycloak.token;
    this.keycloak = keycloak;

    if (!this.token) {
      return this.showErrorMessageAndExit(ERROR.AUTHENTICATION_FAILED);
    }

    this.headersJson = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
        //   withCredentials: true
        crossdomain: true,
        // TODO: verificare gli header in fase di hardening
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        "X-Forwarded-Proto": "https",
        "X-Forwarded-Port": 443
      }
    };
  }

  showErrorMessageAndExit(
    errorMessage = "",
    consoleErrorMessage = "",
    doExit = true
  ) {
    if (consoleErrorMessage) {
      //console.error(consoleErrorMessage);
    }

    if (errorMessage) {
      alert(errorMessage);
    }

    if (doExit) {
      this.keycloak.logoutFn();
    }

    return;
  }

  async genericPostCallWithAlert(
    name,
    url,
    headers,
    fields,
    extra,
    errorMessage = "",
    consoleErrorMessage = "",
    doExit = true
  ) {
    let response = await this.genericPostCall(
      name,
      url,
      headers,
      fields,
      extra
    );

    if (response) {
      if (response.status !== 200) {
        return this.showErrorMessageAndExit(
          response.error.message ? response.error.message : errorMessage,
          consoleErrorMessage ? consoleErrorMessage : response.data.error,
          doExit
        );
      } else {
        return response.data;
      }
    }
  }

  async genericPostCall(name, url, headers, fields, extra) {
    const options = Object.assign(extra || {}, headers);
    // console.debug(`[CeoCbbService:${name}] Calling ${url} with options`, options);

    let response = await Axios.post(url, fields, options)
      .catch(error => {
        //console.error(`[CeoCbbService:${name}] Error`, error.response.data);

        //risposta INTERNAL_SERVER_ERROR
        if (error.response.status === 500) {
          return this.showErrorMessageAndExit(
            ERROR.SERVER_ERROR,
            error.response.data
          );
        } else if (
          //risposta UNAUTHORIZED O FORBIDDEN
          error.response.status === 401 ||
          error.response.status === 403
        ) {
          // let errorMessage = this.keycloak.authenticated
          //   ? ERROR.SESSION_EXPIRED + FORMAT.NL
          //   : FORMAT.EMPTY;
          let errorMessage = ERROR.SERVICE_ACCESS_NOT_AUTHORIZED;

          if (
            (name == "start_election_group_count" ||
              name == "next_election_group_count") &&
            errorMessage == ERROR.SERVICE_ACCESS_NOT_AUTHORIZED &&
            error.response.data == "Counting key errata."
          ) {
            // && this.$i18n.locale != 'en'
            return this.showErrorMessageAndExit(
              "PIN di scrutinio errato.",
              error.response.data,
              false
            );
          }

          return this.showErrorMessageAndExit(
            errorMessage,
            error.response.data
          );
        } else if (error.response.status === 412) {
          return this.showErrorMessageAndExit(
            ERROR.RET_ACCESS_NOT_AUTHORIZED +
              FORMAT.NL +
              ERROR.VERIFY_SCHEDULING,
            error.response.data
          );
        } else if (error.response.status === 400) {
          let errorMessage = error.response.data.error.message
            ? error.response.data.error.message
            : ERROR.SERVER_ERROR;

          return this.showErrorMessageAndExit(
            errorMessage,
            error.response.data
          );
        } else return error.response;
      })
      .then(response => {
        //risposta OK
        if (response) {
          if (response.status === 200) {
            return response;
          }

          //risposta SERVICE_UNAVAILABLE
          if (response.status === 503) {
            return this.showErrorMessageAndExit(ERROR.SERVER_CONNECTION_ERROR);
          } else {
            return response;
          }
        }
      });

    // console.log(`[CeoCbbService:${name}]: Returned data`, response.data);
    return response;
  }

  // ***** CHIAMATE A CEO *****

  async retIdentification() {
    let endpoint = "/returning_officer_identification";
    let fields = {
      Id: "CEO_RETIDENTIFICATION_REQUEST"
    };

    return await this.genericPostCallWithAlert(
      "retIdentification",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.RET_IDENTIFICATION
    );
  }

  async countingInformation() {
    let endpoint = "/counting_information";
    let fields = {
      Id: "CEO_COUNTINGINFORMATION_REQUEST"
    };

    return await this.genericPostCallWithAlert(
      "countingInformation",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.COUNTING_INFORMATION
    );
  }

  async countingStatus() {
    let endpoint = "/counting_status";
    let fields = {
      Id: "CEO_COUNTINGSTATUS_REQUEST"
    };

    return await this.genericPostCallWithAlert(
      "countingStatus",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.COUNTING_STATUS
    );
  }

  async countingReport(groupId, inCountingTaskId) {
    let endpoint = "/election_group_count";
    let fields = {
      Id: "CEO_COUNTINGREPORT_REQUEST",
      GroupId: groupId
    };

    return await this.genericPostCallWithAlert(
      "electionGroupCount",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.ELECTION_GROUP_COUNT
    );
  }

  async countingStart(countingKey, groupIdList, mode) {
    let endpoint = "/start_election_group_count";
    let fields = {
      Id: "CEO_COUNTINGSTART_REQUEST",
      CountingKey: countingKey,
      GroupId: groupIdList,
      Mode: mode
    };

    return await this.genericPostCallWithAlert(
      "start_election_group_count",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.START_ELECTION_GROUP_COUNT
    );
  }

  async nextGroup(countingKey) {
    let endpoint = "/next_election_group_count";
    let fields = {
      Id: "CEO_COUNTINGNEXT_REQUEST",
      CountingKey: countingKey
    };

    return await this.genericPostCallWithAlert(
      "next_election_group_count",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.NEXT_ELECTION_GROUP_COUNT
    );
  }

  async downloadFile(groupId, filetype) {
    let endpoint = "/download";
    let fields = {
      GroupId: groupId,
      FileType: filetype
    };
    let extra = { responseType: "blob" };

    return await this.genericPostCallWithAlert(
      "download",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      extra,
      ERROR.DOWNLOAD
    );
  }

  async sendReportToGEA() {
    let endpoint = "/send_counting_report";
    let fields = {
      Id: "CEO_SENDREPORTTOGEA_REQUEST"
    };

    return await this.genericPostCallWithAlert(
      "send_counting_report",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.COUNTING_INFORMATION
    );
  }

  async stopCounting(countingKey) {
    let endpoint = "/stop_election_group_count";
    let fields = {
      Id: "CEO_COUNTINGSTOP_REQUEST",
      CountingKey: countingKey
    };

    return await this.genericPostCallWithAlert(
      "stop_election_group_count",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      ERROR.STOP_ELECTION_GROUP_COUNT
    );
  }
}

export default CeoCbbService;
